import { render } from "./PreviewImageModal.vue?vue&type=template&id=9a36a140&scoped=true"
import script from "./PreviewImageModal.vue?vue&type=script&lang=js"
export * from "./PreviewImageModal.vue?vue&type=script&lang=js"

import "./PreviewImageModal.vue?vue&type=style&index=0&id=9a36a140&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a36a140"]])

export default __exports__